import { render, staticRenderFns } from "./ModalStatus.vue?vue&type=template&id=03ae14a2&scoped=true"
import script from "./ModalStatus.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalStatus.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ModalStatus.vue?vue&type=style&index=0&id=03ae14a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ae14a2",
  null
  
)

export default component.exports